import { useNavigate } from "react-router-dom";
import { Container, Card, Table, ButtonGroup, Button, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getReviewClaimsPagination, updateCurrentPage, getMaxCount } from "../../3.Store/SUReviewClaimSlice";
import moment from "moment/moment";
import { ThreeDots } from 'react-loader-spinner';
import Pagination from "../../2.Commons/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faCheck, faHourglass, faReply, faMinus } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SUReviewClaimList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const lists = useSelector(state => state.SUReviewClaimSlice.claimlists);
    const currentPage = useSelector(state => state.SUReviewClaimSlice.currentPage);
    const totalPages = useSelector(state => state.SUReviewClaimSlice.totalPages);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const role = JSON.parse(localStorage.getItem("roles"));

    useEffect(() => {
        setLoading(true);
        if (!role || !role.includes("SU-M-BENEFIT")) {  // Check required role 
            localStorage.clear(); 
            window.location.href = "/Login"; 
        }

        if(currentPage) {
            dispatch(getReviewClaimsPagination({currentPage}))
            .then(() => {
                dispatch(getMaxCount())
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
        }
    }, [currentPage]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    const handleBtnBack = () => {
        navigate("/");
    };

    const handleClickView = (id) => {
        navigate(`/SUReviewClaimForm/${id}`)
    };

    const handlePreviousPage = () => {
        setLoading(true);
        if (currentPage > 1) {
          dispatch(updateCurrentPage(currentPage - 1));
          dispatch(getReviewClaimsPagination({ currentPage: currentPage - 1 }))
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
        }
    };
    
    const handleNextPage = () => {
        setLoading(true);
        if (currentPage < totalPages) {
            dispatch(updateCurrentPage(currentPage + 1));
            dispatch(getReviewClaimsPagination({ currentPage: currentPage + 1 }))
            .then(() => {
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
        }
    };

    const handlePageChange = (page) => {
        dispatch(updateCurrentPage(page));
    };

    return (
        <div className="ContainerContent2">
        {loading && (
            <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '9999',
            }}
            />
        )}
        <Card className="CardContent">
            <h1 className="TitleHeader">Supervisor Medical Claims Review</h1>
            <h1 className="MiniTitleHeader">List</h1>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                handlePageChange={handlePageChange}
            />

            <Table className="my-fixed-table" style={{ fontSize: "14px" }}>
            <thead>
                <tr>
                    {isMobile ? (
                        <>
                            <th style={{ width: "50px" }}>Medical Claims</th>
                            <th style={{ width: "15px" }} className="text-center align-middle">Status</th>
                        </>
                    ) : (
                        <>
                            <th style={{ width: "50px" }}>Date Applied</th>
                            <th style={{ width: "90px" }}>Employee</th>
                            <th style={{ width: "90px" }}>Practitioner</th>
                            <th style={{ width: "70px" }}>Receipt No.</th>
                            <th style={{ width: "40px" }} className="text-center align-middle">Claim (RM)</th>
                            <th style={{ width: "40px" }} className="text-center align-middle">Status</th>
                        </>
                    )}
                </tr>
            </thead>
            {!loading && (
            <tbody>
                {lists.length > 0 ? (
                    lists.map(employee => (
                    <tr onClick={() => handleClickView(employee.id)} key={employee.id} style={{ cursor: "pointer" }}>
                        {isMobile ? (
                            <>
                                <td
                                    style={{ 
                                        maxWidth: "200px", 
                                        overflow: "hidden", 
                                        whiteSpace: "nowrap", 
                                        textOverflow: "ellipsis" 
                                    }}
                                >
                                    <strong>{employee.employee.fullname}</strong>
                                    <br/>
                                    <strong>Amount: RM{employee.amount}</strong>
                                    <br/>
                                    <strong>Date: {moment(employee.created).format("YYYY-MM-DD")}</strong>
                                    <br/>
                                    <strong>Practitioner: </strong>{employee.receipt_reference}
                                    <br/>
                                    <strong>Receipt No: </strong>{employee.receipt_no}
                                </td>
                                <td className="text-center align-middle">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>{employee.status.description}</Tooltip>}
                                    >
                                        <span>
                                        {employee.status.description == "APPROVED-HR" && (
                                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                                        )}
                                        {employee.status.description == "APPROVED-S" && (
                                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                                        )}
                                        {employee.status.description == "PENDING" && (
                                            <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                                        )}
                                        {employee.status.description == "WITHDRAWN" && (
                                            <FontAwesomeIcon icon={faReply} style={{color: "#FFD43B",}} />
                                        )}
                                        {employee.status.description == "REJECTED-HR" && (
                                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                                        )}
                                        {employee.status.description == "REJECTED-S" && (
                                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                                        )}
                                        {employee.status.description == "DELETED" && (
                                            <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                                        )}
                                        </span>
                                    </OverlayTrigger>
                                </td>
                            </>
                        ) : (
                            <>
                                <td>{moment(employee.created).format("YYYY-MM-DD")}</td>
                                <td>{employee.employee.fullname}</td>
                                <td>{employee.receipt_reference}</td>
                                <td>{employee.receipt_no}</td>
                                <td className="text-center align-middle">{employee.amount}</td>
                                <td className="text-center align-middle">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>{employee.status.description}</Tooltip>}
                                    >
                                        <span>
                                        {employee.status.description == "APPROVED-HR" && (
                                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                                        )}
                                        {employee.status.description == "APPROVED-S" && (
                                            <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                                        )}
                                        {employee.status.description == "PENDING" && (
                                            <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                                        )}
                                        {employee.status.description == "WITHDRAWN" && (
                                            <FontAwesomeIcon icon={faReply} style={{color: "#FFD43B",}} />
                                        )}
                                        {employee.status.description == "REJECTED-HR" && (
                                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                                        )}
                                        {employee.status.description == "REJECTED-S" && (
                                            <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                                        )}
                                        {employee.status.description == "DELETED" && (
                                            <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                                        )}
                                        </span>
                                    </OverlayTrigger>
                                </td>
                            </>
                        )}
                    </tr>
                    ))
                    ) : (
                    <tr>
                        {/* <td colSpan="6">No results found</td> */}
                        <td colSpan={isMobile ? "2" : "6"}>No results found</td>
                    </tr>
                )}
            </tbody>
            )}
            </Table>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                handlePageChange={handlePageChange}
            />

            {/* <Col style={{ marginLeft: "auto" }}>
                <Form.Label className="FormLabel">{`${currentPage} of ${totalPages}`}</Form.Label> &ensp;
                {currentPage > 1 ? (
                    <Form.Label className="FormLabel" onClick={handlePreviousPage} style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#ffffff" }} />
                    </Form.Label>
                ) : (
                    <Form.Label className="FormLabel" style={{ color: "#cccccc" }}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    </Form.Label>
                )}
                &ensp;
                {currentPage < totalPages ? (
                    <Form.Label className="FormLabel" onClick={handleNextPage} style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faChevronRight} style={{ color: "#ffffff" }} />
                    </Form.Label>
                ) : (
                    <Form.Label className="FormLabel" style={{ color: "#cccccc" }}>
                    <FontAwesomeIcon icon={faChevronRight} />
                    </Form.Label>
                )}
            </Col> */}

            <div className="d-flex justify-content-between">
            <ButtonGroup className="my-2">
                <Button className="Button" onClick={handleBtnBack}>
                Back
                </Button>
            </ButtonGroup>
            </div>
        </Card>
        </div>
    );
};
export default SUReviewClaimList;